import { Box, IconButton, Tooltip } from '@material-ui/core';
import React, { cloneElement, isValidElement, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Payment } from '@material-ui/icons';
import PaymentModal from './PaymentModal';

export default function MakePaymentButton({ trigger, invoiceIds: defaultInvoiceIds, onSuccess, onPayment }) {
  const t = useTranslate();

  const [invoiceIds, setInvoiceIds] = useState([]);

  const handleMakePayment = (e) => {
    e.stopPropagation();
    setInvoiceIds?.(defaultInvoiceIds);
    onPayment?.();
  };

  return (
    <>
      {trigger && isValidElement(trigger) ? (
        cloneElement(trigger, {
          onClick: handleMakePayment,
        })
      ) : (
        <Tooltip title={t('resources.invoice.makePayment')}>
          <Box component={IconButton} onClick={handleMakePayment} size="small" minWidth={30}>
            <Payment fontSize="small" />
          </Box>
        </Tooltip>
      )}
      <PaymentModal setInvoiceIds={setInvoiceIds} invoiceIds={invoiceIds} onSuccess={onSuccess} />
    </>
  );
}
